
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as RestartIconComponent } from "./restart-icon.svg";

export const RestartIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <RestartIconComponent {...props} />;
};
